import { createTheme, ThemeProvider } from '@mui/material'
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router'

import LanguageWrapper, { DEFAULT_LANGUAGE } from './LanguageWrapper'
import Layout from './components/Layout'
import Contact from './pages/Contact'
import Home from './pages/Home'
import LegalNotice from './pages/LegalNotice'
import Services from './pages/Services'
// import WineSelection from './pages/WineSelection'

const theme = createTheme({
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          color: '#3A7551',
        },
      },
    },
  },
  palette: {
    primary: {
      dark: '#4A0513',
      light: '#B2223F',
      main: '#6D071A',
    },
    secondary: {
      dark: '#162A1E',
      light: '#3A7551',
      main: '#214E34',
    },
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Navigate
                to={`/${localStorage.getItem('preferredLang') || DEFAULT_LANGUAGE}`}
                replace
              />
            }
          />
          <Route
            path=":lang"
            element={
              <LanguageWrapper>
                <Layout />
              </LanguageWrapper>
            }
          >
            <Route index element={<Home />} />
            <Route path="services" element={<Services />} />
            {/* <Route path="wine-selection" element={<WineSelection />} /> */}
            <Route path="contact" element={<Contact />} />
            <Route path="legal-notice" element={<LegalNotice />} />
            <Route path="*" element={<div>Not Found</div>} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  )
}

export default App
